import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Section from '../components/Section';
import Card from '../components/Card';
import Button from '../components/Button';
import data from '../data/stdominicana-original';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './HomePage.scss';

const HomePage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
      offset: 100,
    });
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section - Phase 2 ✅ */}
      <Hero
        title={data.hero.title}
        legend={data.hero.legend}
        backgroundImage={data.hero.backgroundImage}
        cta={data.hero.cta}
      />

      {/* About Section - Phase 2 ✅ */}
      <Section
        id="about"
        title={data.about.title}
        variant="default"
      >
        <div className="about-content" data-aos="fade-up">
          <p>{data.about.description}</p>
          {/* <Button variant="primary" size="medium" href={data.about.cta.url}>
            {data.about.cta.text}
          </Button> */}
        </div>
      </Section>

      {/* Mission, Vision & Values Section */}
      <Section
        id={data.missionVisionValues.sectionId}
        title={data.missionVisionValues.title}
        subtitle={data.missionVisionValues.subtitle}
        variant="gradient"
      >
        <div className="mvv-grid">
          {data.missionVisionValues.items.map((item, index) => (
            <div
              key={index}
              className="mvv-card"
              data-aos="flip-up"
              data-aos-delay={index * 150}
            >
              <div className="mvv-card-header" style={{ backgroundColor: item.color }}>
                <h3 className="mvv-card-title">{item.title}</h3>
              </div>
              <div className="mvv-card-body">
                <p className="mvv-card-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <style jsx>{`
          .mvv-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 2rem;
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 1rem;
          }

          .mvv-card {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            height: 100%;
            display: flex;
            flex-direction: column;
          }

          .mvv-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
          }

          .mvv-card-header {
            padding: 1.5rem;
            text-align: center;
          }

          .mvv-card-title {
            color: white;
            font-size: 1.5rem;
            font-weight: bold;
            margin: 0;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          .mvv-card-body {
            padding: 2rem 1.5rem;
            flex: 1;
            display: flex;
          }

          .mvv-card-description {
            color: #333;
            font-size: 1rem;
            line-height: 1.7;
            margin: 0;
            text-align: justify;
          }

          @media (max-width: 768px) {
            .mvv-grid {
              grid-template-columns: 1fr;
              gap: 1.5rem;
            }

            .mvv-card-title {
              font-size: 1.25rem;
            }

            .mvv-card-description {
              font-size: 0.95rem;
              text-align: left;
            }

            .mvv-card-body {
              padding: 1.5rem;
            }
          }
        `}</style>
      </Section>

      {/* Services Section - Phase 2 ✅ */}
      <Section
        id="services"
        title="Nuestras Soluciones"
        subtitle="Nuestra alta especialidad: aislamientos removibles o blankets que es el más idóneo en válvulas y equipos críticamente calientes que necesitan mantenimiento continuo en la industria, planta eléctrica, termoeléctrica y marina (barcos)."
        variant="primary"
      >
        <div className="services-grid">
          {data.services.map((service, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <Card
                title={service.title}
                description={service.description}
                image={service.image}
                href={`/servicios/${service.slug}`}
              />
            </div>
          ))}
        </div>
      </Section>

      {/* Features Section - Phase 2 ✅ */}
      <Section
        id="features"
        title="¿Por qué elegirnos?"
        subtitle="Características que nos hacen únicos en la industria"
        variant="default"
      >
        <div className="features-grid">
          {data.features.map((feature, index) => (
            <div
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <Card
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
              />
            </div>
          ))}
        </div>
      </Section>

      {/* Testimonials Section - Phase 2 ✅ */}
      {/* <Section
        id="testimonials"
        title="Lo que dicen nuestros clientes"
        subtitle="Testimonios reales de empresas satisfechas"
        variant="gradient"
      >
        <div className="testimonials-grid">
          {data.testimonials.map((testimonial, index) => (
            <Card
              key={index}
              title={testimonial.name}
              description={
                <>
                  <p>"{testimonial.text}"</p>
                  <p style={{ marginTop: '1rem', fontWeight: 'bold' }}>
                    {testimonial.company}
                  </p>
                  <p style={{ fontSize: '0.9em', opacity: 0.8 }}>
                    {testimonial.position}
                  </p>
                </>
              }
              className="testimonial-card"
            />
          ))}
        </div>
      </Section> */}

      <section id={data.companyInNumbers.sectionId} className="numbers-section">
        <div
          className="numbers-background"
          style={{ backgroundImage: `url(${data.companyInNumbers.backgroundImage})` }}
        >
          <div className="numbers-overlay"></div>
          <div className="container">
            <div className="numbers-content">
              <h2
                className="numbers-title"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                {data.companyInNumbers.title}
              </h2>
              <div className="numbers-grid">
                {data.companyInNumbers.numbers.map((stat, index) => (
                  <div
                    key={index}
                    className="number-item"
                    data-aos="fade-up"
                    data-aos-delay={200 + (index * 150)}
                  >
                    <div className="number-value">{stat.number}</div>
                    <div className="number-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Phase 2 ✅ */}
      <Section
        id="cta"
        title={data.cta.title}
        subtitle={data.cta.subtitle}
        variant="dark"
      >
        <div style={{ textAlign: 'center' }} data-aos="zoom-in" data-aos-delay="200">
            <a
              href={data.cta.button.url}
              className="btn btn-secondary btn-lg cta-button"
              target="_blank"
              rel="noopener noreferrer"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              Solicita una Cotización
            </a>
        </div>
      </Section>

      {/* Component Test Section - For Development */}
      {/* <Section
        id="component-test"
        title="Component Test - Phase 1 & 2 Complete! ✅"
        subtitle="All components are working with the design system"
        variant="primary"
      >
        <div className="component-status">
          <div className="status-grid">
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Button</h3>
              <p>3 variants, 3 sizes</p>
            </div>
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Section</h3>
              <p>4 variants with overlay</p>
            </div>
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Card</h3>
              <p>Image & icon support</p>
            </div>
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Hero</h3>
              <p>Full-screen with CTA</p>
            </div>
          </div>

          <div style={{ marginTop: '2rem' }}>
            <Button variant="outline" size="medium" href="#about">
              Scroll to About Section
            </Button>
          </div>
        </div>
      </Section> */}
    </div>
  );
};

export default HomePage;
